[
  { "id": 1, "name": "Forward"},
  { "id": 2, "name": "Försvarare"},
  { "id": 3, "name": "Målvakt"},
  { "id": 4, "name": "Mittfältare"},
  { "id": 5, "name": "Mittfältare"},
  { "id": 6, "name": "Försvarare"},
  { "id": 7, "name": "Mittfältare"},
  { "id": 8, "name": "Försvarare"},
  { "id": 9, "name": "Försvarare"},
  { "id": 10, "name": "Forward"},
  { "id": 11, "name": "Forward"},
  { "id": 12, "name": "Forward"},
  { "id": 13, "name": "Mittfältare"},
  { "id": 14, "name": "Försvarare"},
  { "id": 15, "name": "Mittfältare"},
  { "id": 16, "name": "Mittfältare"}
]